export const RulesPatterns = {
    email: new RegExp('^(?!.*\\.@)((?:[A-Za-z0-9!#$%&\'*+\\-\\/=?^_`{|}~]|(?<=^|\\.)"|"(?=$|\\.|@)|(?<=".*)[ .](?=.*")|(?<!\\.)\\.){1,64})(@)((?:[A-Za-z0-9.\\-])*(?:[A-Za-z0-9])\\.(?:[A-Za-z0-9]){2,})$'),
    invalidEmailCharacters: new RegExp("^[^<>|`]+$"),
    invalidCharacters: new RegExp("^[^<>|`~!@#$%^&*\ud83c\ud000-\udfff\ud83d\ud000-\udfff\ud83e\ud000-\udfff]+$"),
    shortBioInvalidCharacters: new RegExp("^[^\ud83c\ud000-\udfff\ud83d\ud000-\udfff\ud83e\ud000-\udfff]+$"),
    postalCode: new RegExp("^[A-Za-z0-9 -]+$"),
    url: new RegExp("^(?:https?:\\/\\/)?(?:[a-zA-Z0-9](?:[-a-zA-Z0-9]*[a-zA-Z0-9])?\\.)+[a-zA-Z]{2,}(?::\\d{1,5})?(?:\\/[-a-zA-Z0-9@:%._\\+~#=]*)*(?:\\?[-a-zA-Z0-9@:%._\\+~#=&]*)?$"),
    urlDomain: new RegExp("(?:https?:\\/\\/)?[-a-zA-Z0-9@:%._\\+~#=]{1,256}\\.[a-zA-Z0-9()]{1,6}(?:\\/[-a-zA-Z0-9@:%._\\+~#=]*)*(\\/)"),
    linkedInUrlDomain: new RegExp("^((?:https?://)?[^/]+/(?:in/)?|[^/]+/)"),
    username: new RegExp("^[A-Za-z0-9@._-]+$"),
    alias: new RegExp("^[a-z0-9]{3,19}$"),
    phoneNumber: new RegExp("^[0-9]{7,15}$"),
};
//# sourceMappingURL=validations.js.map